import { App, defineAsyncComponent } from "vue";

export const sectorDetailsKey: string = 'sector-details';

const SectorToolsPlugin = {
    install( app: App<Element> ) {
        // Register the Category Filter provider
        app.component( sectorDetailsKey, defineAsyncComponent( () => import( '@/components/sectors/SectorDetail.vue' ) ) );
    }
};

export default SectorToolsPlugin;
